import assign from 'lodash/assign';
import get from 'lodash/get';

import { OrderSummary } from 'components/orderSummary/orderSummary';
import { DisplayDeliveryAndShipping } from 'components/displayDeliveryAndShipping/displayDeliveryAndShipping';
import { DisplayBillingAndPayment } from 'components/displayBillingAndPayment/displayBillingAndPayment';
import { Header } from 'components/header/header';
import { HeaderBackground } from 'components/headerBackground/headerBackground';
import { CreateAccount } from 'components/createAccount/createAccount';
import { AuthService } from 'services/auth.service';
import { CheckoutService } from 'services/checkout.service';

import { ThankYouConfirmation } from './thankYouConfirmation/thankYouConfirmation';
import template from './thankYou.html';
import './thankYou.scss';

export const ThankYou = angular
    .module('checkout.components.thankYou', [
        ThankYouConfirmation,
        OrderSummary,
        DisplayDeliveryAndShipping,
        DisplayBillingAndPayment,
        Header,
        HeaderBackground,
        CreateAccount,
        AuthService,
        CheckoutService
    ]).component('thankYou', {
        template,
        bindings: {
            order: '<',
            storeCreditInfo: '<',
            returnUrl: '<',
            storeInfo: '<',
            showCreateAccount: '<',
            isLoggedIn: '<',
            stripeTokenForAccountCreation: '<'
        },
        controller: class ThankYouCtrl {
            constructor($q, apiService, checkoutService, authService) {
                assign(this, {
                    $q,
                    apiService,
                    checkoutService,
                    authService
                });
            }

            onCreateAccountFormSubmit(password) {
                if (!password) return;

                this.creatingAccount = true;

                const { emailAddress } = this.order.placedBy;
                this.apiService.account.create(emailAddress, password)
                    .then(() => {
                        this.showAccountCreatedMessage = true;
                        return this.authService.login(emailAddress, password);
                    })
                    .then(() => {
                        if (this.stripeTokenForAccountCreation) {
                            return this.apiService.account.paymentMethod.add(
                                this.stripeTokenForAccountCreation.token.id,
                                true
                            );
                        }
                        return this.$q.resolve();
                    })
                    .catch((err) => {
                        const title = 'Error creating account';
                        const message = get(err, 'data.message', title);

                        if (err.data && err.data.statusCode === 409) {
                            this.showCreateAccount = false;
                        }

                        this.checkoutService.showErrorDialog(message, title);
                    })
                    .finally(() => {
                        this.creatingAccount = false;
                    });
            }

            onCreateAccountDismissClicked() {
                this.createAccountDismissed = true;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/thankYou/thankYou.js